var map = {
	"./All_notifications_black.svg": "7219",
	"./abnormal_notification_black.svg": "9888",
	"./appointments_black.svg": "8f49",
	"./attach_black.svg": "0d35",
	"./blood_pressure_black.svg": "26fa",
	"./cholesterol_meter_black.svg": "afea",
	"./clipboard_text_black.svg": "cd50",
	"./dashboard_black.svg": "1c44",
	"./devices_black.svg": "6608",
	"./doctor_black.svg": "a6b5",
	"./drop_down_arrow_black.svg": "b615",
	"./edit_black.svg": "5562",
	"./glucose_meter_black.svg": "d8b3",
	"./license-icon-black.svg": "6549",
	"./medical_team_black.svg": "5123",
	"./messages_notification_black.svg": "912d",
	"./missed_notification_black.svg": "c293",
	"./monitoring_plan_black.svg": "04a4",
	"./nurse_black.svg": "1850",
	"./oxymeter_black.svg": "ddf5",
	"./patient_black.svg": "f3ce",
	"./patients_black.svg": "2f62a",
	"./profile_black.svg": "09b9",
	"./scale_black.svg": "7e43",
	"./see_more_black.svg": "afef",
	"./send_button_black.svg": "1bb0",
	"./setings_black.svg": "bf83",
	"./sign_out_black.svg": "a0dc",
	"./thermometer_black.svg": "59c0",
	"./videocall_black.svg": "1ec4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0569";